import findlast from 'lodash.findlast';
import filter from 'lodash.filter';


export const getChapters = (toc) => {
  return filter(toc, { level: 2 });
}

export const getChapter = (chapters, { cfiWithoutAssertions }) => {
  return findlast(chapters, (chap) => {
    return (Jigsaw.CFIUtils.compareCFIs(chap.cfi, cfiWithoutAssertions) <= 0);
  });
};
